/**
 * components/hazard/DescriptionSection.js — Тайлбар хэсэг.
 *
 * Дуу хоолой бичих боломжтой, текст бичих боломжтой.
 *
 * ⚠ ДУУНЫ ТОВЧ нь ГАРЧГИЙН мөрөнд (2026-10-01). Урьд нь текст талбарын
 *   ДООР тусдаа мөр эзэлдэг байсан тул «Зөрчил бүртгэх» цонх хэт өндөр
 *   болж, доод талын талбарууд (хариуцагч, хугацаа) гүйлгэхгүйгээр
 *   харагддаггүй байв. Товчийг гарчгийн баруун талд оруулснаар ~44px,
 *   мөрийн тоог 5→4 болгосноор дахин ~24px хэмнэв.
 * ⚠ `resize: "vertical"` — урт тайлбар бичих хэрэгтэй хүн өөрөө томруулна
 *   (өмнө нь `none` байсан тул 4 мөр нь хязгаарлалт болох байлаа).
 *
 * Props:
 *   value           : string
 *   onChange        : (text) => void
 *   maxLen          : default 1500
 *   voiceFileUrl    : optional — дуу хоолойн файлын URL хадгалах
 *   onVoiceUrl      : (url) => void
 */
import React from "react";
import VoiceRecorder from "src/components/VoiceRecorder";
import { Card, SectionTitle, inputStyle } from "./common";

export default function DescriptionSection({
  value = "",
  onChange,
  maxLen = 1500,
  voiceFileUrl,
  onVoiceUrl,
  placeholder = "Тохиолдсон аюул, эрсдэлийн талаар дэлгэрэнгүй бичнэ үү...",
  title = "Тайлбар",
  /* ⚠ ЗӨРЧЛИЙН тайлбар нь ЗААВАЛ (серверийн `FINDING_REQUIRED`) —
     аюулын мэдээлэлд заавал БИШ тул дуудагч шийднэ (2026-11-05). */
  required = false,
}) {
  return (
    <Card>
      <SectionTitle
        required={required}
        right={
          <span
            style={{ display: "inline-flex", alignItems: "center", gap: 10 }}
          >
            <VoiceRecorder
              compact
              onTranscript={(text) =>
                onChange?.(
                  ((value ? value.trim() + " " : "") + text).slice(0, maxLen),
                )
              }
              onAudioUploaded={(url) => onVoiceUrl?.(url)}
            />
            <span style={{ whiteSpace: "nowrap" }}>
              {value.length}/{maxLen}
            </span>
          </span>
        }
      >
        {title}
      </SectionTitle>
      <textarea
        value={value}
        onChange={(e) => onChange?.(e.target.value.slice(0, maxLen))}
        rows={4}
        placeholder={placeholder}
        style={{
          ...inputStyle,
          resize: "vertical",
          lineHeight: 1.5,
        }}
      />
      {voiceFileUrl && (
        <div
          style={{
            marginTop: 6,
            fontSize: 11,
            color: "#7A8496",
            fontStyle: "italic",
          }}
        >
          🎤 Дуу хоолойн файл хадгалагдсан
        </div>
      )}
    </Card>
  );
}
